import { Typography } from "@material-ui/core";

export const EditRentalPortfolio = () => {
  return (<Typography>Rental Portfolio</Typography>);
}